export const formatTableData = (data: PivotResponseItem[], defaults: string[]): PivotResponseItem[] => {
    return data.map(item => {
      if (defaults.includes(item.uid)) {
        return item;
      }
  
      const defaultVersion = item.versions.find(version => defaults.includes(version.uid));
      
      if (defaultVersion) {
        const { versions, expand, ...itemWithoutVersions } = item;
        return {
          ...defaultVersion,
          versions: [
            { ...itemWithoutVersions },
            ...item.versions.filter(v => v.uid !== defaultVersion.uid)
          ],
          expand: item.expand
        };
      }
      return item;
    });
  };